module.exports = __webpack_public_path__ + "img/MapThumb_GoldRush.87598d96.webp";